import Component from '@Component';

const openClass = 'modal--open';

export default class MicroModalAdaptor extends Component {
  static selector = '[data-comp-modal-trigger]'

  constructor(...args) {
    super(...args);
    this.modalId = `${this.$container.dataset.compModalTrigger}-modal`;
    this.modalContainer = document.getElementById(this.modalId);

    if (!this.modalContainer) {
      console.warn(`[MicroModalAdaptor] Modal with id '${this.modalId} is not found.`);
      return;
    }

    this.modalController = null;
    this.modalCloseTriggers = this.modalContainer.querySelectorAll('[data-comp-modal-close-trigger]');
    this.boundApplyHiddenStyles = () => this.applyHiddenStyles();
    this.events();
  }

  async loadDependencies() {
    const module = await import('micromodal');
    this.modalController = module.default;
  }

  async show() {
    // Force all images to load if they haven't already.
    // This provides a slight performance improvement by loading images early,
    // and fixes a bug in Safari 14 where IntersectionObserver doesn't get triggered correctly
    // while using position: fixed.
    this.modalContainer.querySelectorAll('[data-src]').forEach(img => img.component.init());

    if (!this.modalController) await this.loadDependencies();

    this.setEventDatasetAttributes();

    this.modalController.show(this.modalId, {
      awaitCloseAnimation: true,
      disableScroll: true,
      openClass,
    });
  }

  async close() {
    if (!this.modalController) await this.loadDependencies();
    this.removeEventDatasetAttributes();
    this.modalController.close(this.modalId);
    this.modalContainer.addEventListener('animationend', this.boundApplyHiddenStyles);
  }

  setEventDatasetAttributes() {
    const { dataset } = this.$container;
    this.setTrackedElementAttributes(dataset.eventCategory, dataset.eventLabel);
    this.setModalAttributes(
      dataset.eventCategory, dataset.eventAction, dataset.eventLabel,
    );
  }

  removeEventDatasetAttributes() {
    this.setTrackedElementAttributes();
    this.setModalAttributes();
  }

  setTrackedElementAttributes(eventCategory = '') {
    this.modalEventTrackedElements = this.modalContainer.querySelectorAll('[data-modal-child-event]');
    this.modalEventTrackedElements.forEach(el => {
      const { dataset } = el;
      dataset.eventCategory = eventCategory;
    });
  }

  setModalAttributes(eventCategory = '', eventAction = '', eventLabel = '') {
    this.modalContainer.dataset.eventCategory = eventCategory;
    this.modalContainer.dataset.eventAction = eventAction;
    this.modalContainer.dataset.eventLabel = eventLabel;
  }

  applyHiddenStyles() {
    this.modalContainer.removeEventListener('animationend', this.boundApplyHiddenStyles);
    this.modalContainer.classList.remove(openClass);
  }

  events() {
    this.$container.addEventListener('click', () => this.show());
    this.modalCloseTriggers.forEach(el => el.addEventListener('click', () => this.close()));
  }
}
